import {
  CAN_CHANGE_PASSWORD_SUCCESS,
  GET_ALL_SUGGESTED_CONTACTS_FAILED,
  GET_ALL_SUGGESTED_CONTACTS_REQUEST,
  GET_ALL_SUGGESTED_CONTACTS_SUCCESS,
  LOGOUT,
} from 'actions';

import createReducer from './createReducer';

interface ProfileState {
  canChangePassword: boolean | null;
  loading: boolean;
  loaded: boolean;
}

const INITIAL_STATE: ProfileState = {
  canChangePassword: null,
  loading: false,
  loaded: false,
};

type DataAction = {
  type: string;
  data?: boolean;
};

export default createReducer(INITIAL_STATE, {
  [CAN_CHANGE_PASSWORD_SUCCESS]: (state, action?: DataAction) => {
    const data = action?.data;
    if (data === undefined) {
      return state;
    }
    return {
      ...state,
      canChangePassword: data,
    };
  },
  [GET_ALL_SUGGESTED_CONTACTS_REQUEST]: (state) => ({
    ...state,
    loading: true,
  }),
  [GET_ALL_SUGGESTED_CONTACTS_SUCCESS]: (state) => ({
    ...state,
    loading: false,
    loaded: true,
  }),
  [GET_ALL_SUGGESTED_CONTACTS_FAILED]: (state) => ({
    ...state,
    loading: false,
  }),
  [LOGOUT]: () => ({ ...INITIAL_STATE }),
});
